import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './routes';
import config from '../config';
import auth from '@bluedot-tech/vue-ui/es/utils/auth.js';

const wx = require('weixin-js-sdk');

Vue.use(VueRouter);

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
});

// 授权
const handelAuth = auth({
	config: {
		...config.wechat,
		storagePrefix: config.storagePrefix
	}
});

// jssdk设置
const handelJssdk = () => {
	Vue.axios
		.get(config.jssdk.url, {
			params: {
				// referer_url: encodeURIComponent(window.location.href.split('#')[0]),
				referer_url: window.location.href,
				appid: config.appid,
				js_api_list: config.jssdk.jsApiList.join(',')
			}
		})
		.then(res => {
			wx.config({
				// debug: true,
				appId: res.data.appId,
				timestamp: res.data.timestamp,
				nonceStr: res.data.nonceStr,
				signature: res.data.signature,
				jsApiList: config.jssdk.jsApiList
			});
		});
};

// 路由守卫前置钩子
router.beforeEach((to, from, next) => {
	Vue.prototype.$loading.show();
	const { meta }: any = to;
	if (!meta.wechatAuth) {
		next();
		return;
	}
	handelAuth(to, from, next);
});

// 路由守卫后置钩子
router.afterEach(() => {
	Vue.prototype.$loading.hide();
	handelJssdk();
});

export default router;
